import basesApiService from '@/services/api/Bases'

const emptyModel = {
  name: null,
  address: null,
  country_id: null
}

const emptyFilters = {
  name: null,
  address: null,
  country_id: null
}

export default class Base {
  static api = basesApiService
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
}
